const getOrderFilters = (queryParams, filters) => {
  const queryFilters = [];
  let queryString = queryParams;
  if (filters.from && filters.to) {
    queryString += `&from=${filters.from}&to=${filters.to}`;
  } else if (filters.from) {
    queryString += `&from=${filters.from}`;
  } else if (filters.to) {
    queryString += `&to=${filters.to}`;
  }
  if (filters.deliveryOption) {
    queryFilters.push(`deliveryOption=${filters.deliveryOption}`);
  }
  if (filters.locationIds.length > 0) {
    queryFilters.push(`locationIds: ${filters.locationIds.join(',')}`);
  }
  if (filters.orderStatus) {
    queryFilters.push(`orderStatus=${filters.orderStatus}`);
  }
  if (queryFilters.length > 0) {
    queryString += `&filter=${queryFilters.join('AND')}`;
  }
  if (filters.searchText) {
    queryString += `&q=${filters.searchText}`;
  }
  return queryString;
};

export { getOrderFilters };
